// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class PatchMapData implements flatbuffers.IUnpackableObject<PatchMapDataT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchMapData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchMapData(bb:flatbuffers.ByteBuffer, obj?:PatchMapData):PatchMapData {
  return (obj || new PatchMapData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchMapData(bb:flatbuffers.ByteBuffer, obj?:PatchMapData):PatchMapData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchMapData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

bio():string|null
bio(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
bio(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startPatchMapData(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, dnameOffset, 0);
}

static addBio(builder:flatbuffers.Builder, bioOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, bioOffset, 0);
}

static endPatchMapData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPatchMapData(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset, bioOffset:flatbuffers.Offset):flatbuffers.Offset {
  PatchMapData.startPatchMapData(builder);
  PatchMapData.addDname(builder, dnameOffset);
  PatchMapData.addBio(builder, bioOffset);
  return PatchMapData.endPatchMapData(builder);
}

unpack(): PatchMapDataT {
  return new PatchMapDataT(
    this.dname(),
    this.bio()
  );
}


unpackTo(_o: PatchMapDataT): void {
  _o.dname = this.dname();
  _o.bio = this.bio();
}
}

export class PatchMapDataT implements flatbuffers.IGeneratedObject {
constructor(
  public dname: string|Uint8Array|null = null,
  public bio: string|Uint8Array|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const bio = (this.bio !== null ? builder.createString(this.bio!) : 0);

  return PatchMapData.createPatchMapData(builder,
    dname,
    bio
  );
}
}
